module.exports = "/_next/static/images/associationLogo1-51d35f77b4871d66693b9c4a75d34f92.webp";